module.exports = __webpack_public_path__ + "static/img/analysis4.3208825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/analysis4.png
// module id = og7R
// module chunks = 1